import { apiGet, apiSend } from './client';
import type { ServerRaidContentState, ServerRecord } from './types';

export interface ServerFormPayload {
  slug: string;
  name: string;
  aliases: string[];
  isActive: boolean;
}

export async function fetchAdminServers() {
  const data = await apiGet<{ servers: ServerRecord[] }>('/admin/servers');
  return data.servers;
}

export async function createAdminServer(payload: ServerFormPayload) {
  const data = await apiSend<{ server: ServerRecord }>('/admin/servers', 'POST', payload);
  return data.server;
}

export async function updateAdminServer(id: number, payload: ServerFormPayload) {
  const data = await apiSend<{ server: ServerRecord }>(`/admin/servers/${id}`, 'PUT', payload);
  return data.server;
}

export async function deleteAdminServer(id: number) {
  await apiSend<{ deleted: boolean }>(`/admin/servers/${id}`, 'DELETE');
}


export interface ServerContentStatePayload {
  isActive: boolean;
  unlocksAt?: string | null;
  startsAt?: string | null;
  endsAt?: string | null;
  isFrozen?: boolean;
  notes?: string | null;
}

export async function fetchServerRaidContent(serverId: number) {
  const data = await apiGet<{ content: ServerRaidContentState }>(`/admin/servers/${serverId}/raid-content`);
  return data.content;
}

export async function initializeServerRaidContent(serverId: number) {
  const data = await apiSend<{ content: ServerRaidContentState }>(`/admin/servers/${serverId}/raid-content/initialize`, 'POST', {});
  return data.content;
}

export async function updateServerExpansionState(serverId: number, expansionId: string, payload: ServerContentStatePayload) {
  const data = await apiSend<{ content: ServerRaidContentState }>(`/admin/servers/${serverId}/raid-content/expansions/${expansionId}`, 'PUT', payload);
  return data.content;
}

export async function updateServerRaidTierState(serverId: number, raidTierId: string, payload: ServerContentStatePayload) {
  const data = await apiSend<{ content: ServerRaidContentState }>(`/admin/servers/${serverId}/raid-content/tiers/${raidTierId}`, 'PUT', payload);
  return data.content;
}

export async function updateServerRankingPartitionState(serverId: number, rankingPartitionId: string, payload: ServerContentStatePayload) {
  const data = await apiSend<{ content: ServerRaidContentState }>(`/admin/servers/${serverId}/raid-content/partitions/${rankingPartitionId}`, 'PUT', payload);
  return data.content;
}
